import { useAuthLogout } from '@/app/hooks/auth/useAuthLogout'
import { isValidRedirect } from '@/app/lib/auth'
import { ROUTES } from '@/app/lib/constants'
import { useEffect } from 'react'
import { useQueryClient } from 'react-query'
import { useNavigate, useSearchParams } from 'react-router-dom'

export default function AuthLogoutPage() {
  const { mutateAsync: logout } = useAuthLogout()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const queryClient = useQueryClient()

  const redirectTo = searchParams.get('redirectTo') ?? ROUTES.homepage

  // we need to encode this because useSearchParams automatically decodes the
  // params for us.
  const encodedRedirectTo = encodeURIComponent(redirectTo)

  useEffect(() => {
    ;(async () => {
      try {
        await logout()
        await queryClient.clear()
      } catch {
        // Ignore logout errors
      }

      if (isValidRedirect(redirectTo) && redirectTo.startsWith('http')) {
        window.location.href = redirectTo
      } else {
        const queryParams = new URLSearchParams()
        if (isValidRedirect(redirectTo)) {
          queryParams.set('redirectTo', encodedRedirectTo)
        }

        const loginPath = queryParams.toString()
          ? `${ROUTES.login}?${queryParams.toString()}`
          : ROUTES.login

        navigate(loginPath, { replace: true })
      }
    })()
  }, [logout, navigate, encodedRedirectTo, redirectTo])

  return null
}
